// 获取data-time格式
const formatTime = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [year, month, day].map(formatNumber).join('-')
}

const formatTime2 = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()

	return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatSeconds = function(value) {
	let result = parseInt(value)
	let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
	let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 %
		60))
	let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
	result = `${h}:${m}:${s}`
	return result
}

// 只获取月日
const formatTimes = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [month, day].map(formatNumber).join('-')
}

const formatTimesd = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [year, month, day].map(formatNumber).join('-')
}

// 获取中文年月份
const formatTimeCn = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return {
		year: year + '年',
		month: month + '月',
		day: day + '日'
	}
}

const formatTimeCns = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return [year, month, day].map(formatNumber).join('-')
}
// 获取纯数字年月份
const formatTimeNum = date => {
	const year = date.getFullYear()
	const month = date.getMonth() + 1
	const day = date.getDate()
	const hour = date.getHours()
	const minute = date.getMinutes()
	const second = date.getSeconds()
	return {
		year: year,
		month: month,
		day: day
	}
}
const mGetDate = (year, month) => {
	var d = new Date(year, month, 0);
	return d.getDate();
}


const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : '0' + n
}

/*删除数组中的某个一个元素*/
const remove = (arr, ele) => {
	var index = arr.indexOf(ele);
	if (index > -1) {
		arr.splice(index, 1);
	}
	return arr;
}

// 倒计时 endtime 传入时间戳
var showDownTime = function(endtime) {
	var nowtime = new Date().getTime(), //获取当前时间戳
		endtime = endtime; //定义结束时间
	var lefttime = endtime - nowtime //距离结束时间的毫秒数
	if (lefttime < 0 || lefttime == 0) {
		return {
			downDay: 0,
			downHour: '00',
			downMinute: '00',
			downSecond: '00'
		}
	} else {
		var leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)) || 0 //计算天数
		var lefth = Math.floor(lefttime / (1000 * 60 * 60) % 24) || 0 //计算小时数
		var leftm = Math.floor(lefttime / (1000 * 60) % 60) || 0 //计算分钟数
		var lefts = Math.floor(lefttime / 1000 % 60) || 0; //计算秒数
		return {
			downDay: leftd, //天
			downHour: lefth < 10 ? '0' + lefth : lefth, //时
			downMinute: leftm < 10 ? '0' + leftm : leftm, //分
			downSecond: lefts < 10 ? '0' + lefts : lefts //秒
		}
	}
}
const checkStrType = (str, type) => {
	switch (type) {
		case 'phone': //手机号码
			return /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(str);
		case 'tel': //座机
			return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
		case 'card': //身份证
			return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(str);
		case 'pwd': //密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
			return /^[a-zA-Z]\w{5,17}$/.test(str)
		case 'postal': //邮政编码
			return /[1-9]\d{5}(?!\d)/.test(str);
		case 'QQ': //QQ号
			return /^[1-9][0-9]{4,9}$/.test(str);
		case 'email': //邮箱
			return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str);
		case 'money': //金额(小数点2位)
			return /^\d*(?:\.\d{0,2})?$/.test(str);
		case 'URL': //网址
			return /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/.test(str)
		case 'IP': //IP
			return /((?:(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d)\\.){3}(?:25[0-5]|2[0-4]\\d|[01]?\\d?\\d))/.test(str);
		case 'date': //日期时间
			return /^(\d{4})\-(\d{2})\-(\d{2}) (\d{2})(?:\:\d{2}|:(\d{2}):(\d{2}))$/.test(str) ||
				/^(\d{4})\-(\d{2})\-(\d{2})$/
				.test(str)
		case 'number': //数字
			return /^[0-9]$/.test(str);
		case 'english': //英文
			return /^[a-zA-Z]+$/.test(str);
		case 'chinese': //中文
			return /^[\\u4E00-\\u9FA5]+$/.test(str);
		case 'lower': //小写
			return /^[a-z]+$/.test(str);
		case 'upper': //大写
			return /^[A-Z]+$/.test(str);
		case 'HTML': //HTML标记
			return /<("[^"]*"|'[^']*'|[^'">])*>/.test(str);
		default:
			return true;
	}

}

//数组深拷贝
const deepCopy = (obj) => {
	// 只拷贝对象
	if (typeof obj !== 'object') return;
	// 根据obj的类型判断是新建一个数组还是一个对象
	var newObj = obj instanceof Array ? [] : {};
	for (var key in obj) {
		// 遍历obj,并且判断是obj的属性才拷贝
		// 如果值是null，typeof也是object类型，这是个坑


		if (obj.hasOwnProperty(key)) {
			// 判断属性值的类型，如果是对象递归调用深拷贝
			newObj[key] = (typeof obj[key] === 'object' && obj[key] != null) ? deepCopy(obj[key]) : obj[key];
		}
	}
	return newObj;
}

// 上传文件转换为base64,这个file参数就是文件信息
const getBase64 = (file) => {
	return new Promise((resolve, reject) => {
		let reader = new FileReader();
		let fileResult = "";
		reader.readAsDataURL(file);
		//开始转
		reader.onload = function() {
			fileResult = reader.result;
		};
		//转失败
		reader.onerror = function(error) {
			reject(error);
		};
		//转结束resolve 出去
		reader.onloadend = function() {
			resolve(fileResult);
		};
	});
}
//对菜单进行排序
const sortRouters = (accessedRouters) => {
	for (let i = 0; i < accessedRouters.length; i++) {
		let router = accessedRouters[i];
		if (router.children && router.children.length > 0) {
			router.children.sort(compare("sort"));
		}
	}
	accessedRouters.sort(compare("sort"));
}
//升序比较函数
const compare = (p) => {
	return function(m, n) {
		let a = m[p];
		let b = n[p];
		return a - b;
	}
}
const log = (val) => {
	console.log(val)
}


export default {
	formatSeconds: formatSeconds,
	formatTime: formatTime,
	formatTimeCn: formatTimeCn,
	formatTimeNum: formatTimeNum,
	mGetDate: mGetDate,
	checkStrType: checkStrType,
	showDownTime: showDownTime,
	deepCopy: deepCopy,
	getBase64: getBase64,
	sortRouters: sortRouters,
	log: log,
	formatTimeCns: formatTimeCns,
	formatTimes: formatTimes,
	formatTimesd: formatTimesd,
	formatTime2:formatTime2
}



// WEBPACK FOOTER //
// ./src/utlis/getTime.js